import React from 'react';
import { Container } from 'react-bootstrap';

export const About = () => {
    return (
        <Container>
            <h1>Welcome to the new agency portal called AgencyHub (formerly DesigWeb)!</h1>
            
            <p>
                The newly enhanced design of AgencyHub improves communication regarding the funds distributed to your agency via United Way of Greater Los Angeles.
            </p>
            
            <h2>The new upgraded features include:</h2>
            <ul>
                <li>Instant online access to donor disbursement information, donor details, and detailed reports.</li>
                <li>New reports include the ability to “drill-down” into a remittance report to see all contributing donors. The enhanced reports allow you to see your campaign in total or by disbursement.</li>
                <li>View your entire donor list for the current disbursement period.</li>
            </ul>
        </Container>
    );
};
